<section class="pit-card pit-card--flush docs" aria-labelledby="pit-docs-title">
  <!-- Cabeçalho: título, resumo dos status e o link para a pasta. -->
  <div class="docs__head">
    <div>
      <h3 id="pit-docs-title" class="pit-title">Declarações no Data Room</h3>
      @if (store.summary()) {
        <p class="pit-caption">{{ store.summary() }}</p>
      }
    </div>
    @if (canOpenFolder()) {
      <button type="button" class="pit-link" (click)="openFolder.emit()">
        {{ folderLabel() }}
      </button>
    }
  </div>

  <div class="docs__body">
    @if (store.loading() && !store.loaded()) {
      <div class="docs__state">
        <app-cog-loading-spinner [size]="32" />
        <p class="pit-text">Buscando as declarações no Data Room...</p>
      </div>
    } @else if (store.error(); as message) {
      <div class="docs__state">
        <p class="pit-text">{{ message }}</p>
        <app-button
          [label]="'Tentar de novo'"
          theme="outline-grey"
          [outlined]="true"
          [size]="'small'"
          [fitContent]="true"
          (sendButtonClick)="store.retry()" />
      </div>
    } @else if (!store.documents().length) {
      <div class="docs__state">
        <p class="pit-text">Nenhuma declaração na pasta IRPF desta empresa.</p>
        @if (canOpenFolder()) {
          <app-button
            [label]="folderLabel()"
            [fitContent]="true"
            (sendButtonClick)="openFolder.emit()" />
        }
      </div>
    } @else {
      @if (state.canUpdate()) {
        <!--
          Ação navy pequena à direita, com nome que diz o que faz (card 3799: "Ler selecionados" grande se confundia com
          abrir o documento); o atalho de seleção, como texto, ao lado.
        -->
        <div class="docs__actions">
          <p class="pit-caption docs__hint">
            Clique no nome para abrir o PDF. Para o Cog extrair os dados de novo, marque o documento
            e use Extrair dados.
          </p>
          <div class="docs__buttons">
            @if (store.pending().length) {
              <button
                type="button"
                class="pit-link"
                [disabled]="store.reading()"
                (click)="selectPending()">
                Marcar não lidos e com erro ({{ store.pending().length }})
              </button>
            }
            <app-button
              [label]="readLabel()"
              icon="pi pi-sparkles"
              [size]="'small'"
              [title]="
                'O Cog lê o PDF marcado e atualiza os dados do sócio. Leva cerca de 1 min por documento.'
              "
              [fitContent]="true"
              [disabled]="!selected().length || store.reading()"
              [isLoading]="store.reading()"
              (sendButtonClick)="readSelected()" />
          </div>
        </div>
      }

      <app-table
        #table
        [items]="store.documents()"
        [columnDefinitions]="columns"
        [dataKey]="'documentId'"
        [hasCheckbox]="state.canUpdate()"
        [isRowSelectable]="isSelectable"
        [hasPagination]="store.documents().length > pageSize"
        [inMemoryPagination]="store.documents().length > pageSize"
        [ellipsisMenuConfig]="{ enabled: false }"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 20, 50]"
        [loading]="store.loading() && !store.loaded()"
        (sendTableSelection)="onSelection($event)">
        <ng-template appNamedTemplate="fileName" let-item>
          <!-- Nome abre o PDF na pré-visualização (DATAROOM_LIST_LINK_ATTACHAMENT, a do download-link). -->
          @if (canOpenFile()) {
            <button
              type="button"
              class="docs__file docs__file--link"
              [title]="'Abrir ' + item.fileName"
              [disabled]="openingId() === item.documentId"
              (click)="$event.stopPropagation(); openDocument(item)">
              <i class="pi pi-file-pdf docs__file-icon" aria-hidden="true"></i>{{ item.fileName }}
            </button>
          } @else {
            <span class="docs__file" [title]="item.fileName">{{ item.fileName }}</span>
          }
          <!-- Data e hora (pedido do Victor, 29/10/2026): vários envios no mesmo dia se distinguem pela hora. -->
          <span class="pit-caption docs__block"
            >Enviado em {{ item.uploadedAt | vaultDateTime }}</span
          >
        </ng-template>
        <ng-template appNamedTemplate="kind" let-item>
          {{ kindLabels[item.kind] ?? 'Documento' }}
        </ng-template>
        <ng-template appNamedTemplate="partnerName" let-item>
          {{ item.partnerName ? personName(item.partnerName) : '—' }}
        </ng-template>
        <ng-template appNamedTemplate="exerciseYear" let-item>
          <span class="docs__num">{{ item.exerciseYear ?? '—' }}</span>
        </ng-template>
        <ng-template appNamedTemplate="status" let-item>
          <!-- Selo numa linha só, alinhado com as outras células (N12); a data da leitura vai no title. -->
          <span class="docs__status">
            <span
              [class]="'pit-tag ' + statusTags[item.status].css"
              [title]="
                item.status === 'read' && item.lastReadAt
                  ? 'Lida em ' + (item.lastReadAt | vaultDateTime)
                  : statusTags[item.status].label
              ">
              @if (statusTags[item.status].busy) {
                <app-cog-loading-spinner [size]="12" />
              } @else if (statusTags[item.status].icon; as icon) {
                <i [class]="icon" aria-hidden="true"></i>
              }
              {{ statusTags[item.status].label }}
            </span>
            @if (item.status === 'failed' && item.message) {
              <span class="docs__error" [title]="item.message">{{ item.message }}</span>
            }
            @if (stageText(item); as stage) {
              <!-- Etapa e tempo da leitura em andamento (card 3772). -->
              <span class="pit-caption docs__stage" [title]="stageTitle(item, stage)">{{
                stage
              }}</span>
            } @else if (item.status === 'read' && item.lastReadAt) {
              <!-- Mesma altura das linhas em leitura: a data da leitura embaixo do selo (card 3772). -->
              <span class="pit-caption docs__stage">em {{ item.lastReadAt | vaultDateTime }}</span>
            }
          </span>
        </ng-template>
      </app-table>
    }
  </div>
</section>
